var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#c91281",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-307 -248) translate(307 248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.044 25H1.956C.878 25 0 24.123 0 23.044V3.52c0-1.08.878-1.958 1.957-1.958h21.086c1.079 0 1.957.879 1.957 1.958v19.524C25 24.123 24.123 25 23.044 25zM1.957 3.125c-.217 0-.395.177-.395.395v19.524c0 .217.177.393.394.393h21.088c.217 0 .393-.176.393-.393V3.52c0-.218-.177-.395-.394-.395H1.957zm22.262 4.688H.78C.35 7.813 0 7.463 0 7.03 0 6.6.35 6.25.781 6.25H24.22c.432 0 .781.35.781.781 0 .432-.35.782-.781.782zM4.687 4.688c-.43 0-.78-.35-.78-.782V.781c0-.431.35-.781.78-.781.432 0 .782.35.782.781v3.125c0 .432-.35.781-.782.781zm15.625 0c-.432 0-.78-.35-.78-.782V.781c0-.431.348-.781.78-.781.433 0 .782.35.782.781v3.125c0 .432-.35.781-.782.781z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 20,
    r: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.64b2fac3.svg";
export { ForwardRef as ReactComponent };